// Gift.js
import { connect } from 'react-redux';
import sendGift from '../action/sendGift.js';
import addvalue from '../action/addvalue.js';
import login from '../action/login.js';
import openQuickpayModal from '../action/openQuickpayModal.js';
import getGiftData from '../selector/getGiftData.js';
import getOperationData from '../selector/getOperationData.js';
import getHasEnoughBalanceForGift from '../selector/getHasEnoughBalanceForGift.js';
import getMeData from '../selector/getMeData.js';
import Gift from '../component/Gift.jsx';

const getGiftI18nKey = id => `giftname_${id.replace(/-/g, '_')}`;

/**
 * mapStateToProps
 * @param {Object} state - the root state from redux store
 * @param {string} { id } - gift id
 * @return {Object} the object will be the props in the connected component
 */
function mapStateToProps(state, { id }) {
  return {
    i18nKey: getGiftI18nKey(id),
    image: getGiftData(state, id, 'image'),
    price: getGiftData(state, id, 'price'),
    isDisabled: getGiftData(state, id, 'isDisabled'),
    isSwiping: getOperationData(state, ['gift', 'panel'], 'isSwiping'),
    hasEnoughBalance: getHasEnoughBalanceForGift(state, id),
    isLoggedIn: !!getMeData(state, 'token'),
  };
}

function mapDispatchToProps(dispatch, { userId, chatroomId }) {
  return {
    sendGift: ({ giftId }) =>
      dispatch(sendGift({ userId, giftId, chatroomId })),
    addvalue: () => dispatch(addvalue({ via: 'gift' })),
    login: () => dispatch(login({ isRequireDiamond: true })),
    openQuickpayModal: data => dispatch(openQuickpayModal(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Gift);
